module.exports = __webpack_public_path__ + "img/c02_buildingstartechplacermining_Normal_ua.2c80d942.webp";